import { render, staticRenderFns } from "./InventoryAging.vue?vue&type=template&id=6ec9065b&"
import script from "./InventoryAging.vue?vue&type=script&lang=js&"
export * from "./InventoryAging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports